<template>
  <div>
    <div style="margin:10px 0;display:flex;justify-content: space-between;">
      <div style="display:flex;">
        <div v-if="totalData" style="eight: 40px;line-height: 40px;width: 391px;">
          <span class="plate-title" style="color: #333;">Tour Records : </span>
          <span style="margin-right:35px;"><span style="font-weight:600">Completed </span>({{ totalData.totalCompleted }})</span>
          <span><span style="font-weight:600">Cancelled </span>({{ totalData.totalCancelled }})</span>
        </div>
      </div>
      <div style="text-align: right;font-size: 14px;font-weight: 400;padding-top: 10px;">
        <a @click="showTourRecordsModal(null)" :disabled="!$auth('CDB_CUSTOMER_ADD')"><a-icon type="plus"/> Add</a>
      </div>
    </div>

    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="5" :sm="24">
            <a-form-item label="Tour Code">
              <a-input v-model="queryParam.tourCode" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="Booking No.">
              <a-input v-model="queryParam.bookId" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="Status">
              <a-select v-model="queryParam.cancelFlag" placeholder="Please select" @change="handleQueryChange">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="0">Completed</a-select-option>
                <a-select-option value="1">Cancelled</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 4 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="reset">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="tourCode" slot-scope="text, record"><span>{{ record.tourCode }}</span></span>
      <span slot="bookId" slot-scope="text, record">
        <template>
          <span v-if="(record.tourCode.substring(0, 2) === 'SN' || record.tourCode.substring(0, 2) === 'SV') && record.tourCode.length <= 8">{{ record.bookId }}</span>
          <span v-else><a :href="getOBSCodeUrl(record.bookId)" target="_blank">{{ record.bookId }}</a></span>
        </template>
      </span>
      <span slot="startDate" slot-scope="text">
        {{ dateFormatB(text) }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a-popconfirm
            title="Are you sure delete?"
            @confirm="onDeleteConfirmed(record)"
            okText="Yes"
            cancelText="No"
          >
            <a href="javascript:;" :disabled="!$auth('CDB_CUSTOMER_DELETE')">Delete</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <!-- 表单 -->
    <a-modal
      :visible="currentTourRecordIndex !== null"
      title="Tour Record"
      @cancel="handleModalCancel"
      :maskClosable="false"

    >
      <template slot="footer">
        <a-button key="back" @click="handleModalCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="saving" @click="handleModalConfirm">Save</a-button>
      </template>
      <a-form :form="editForm" autocomplete="off" class="ant-advanced-search-form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Tour Code"
        >
          <a-input
            v-decorator="[
              'tourCode',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input Tour Code.',
                  },
                ],
              },
            ]"
            placeholder="Tour Code"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Booking No."
        >
          <a-input 
            v-decorator="[
              'bookId',
              {
                rules: [
                  {
                    required: false,
                    message: 'Please input Booking No.',
                  },
                ],
              },
            ]"
            placeholder="Booking No."
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Status"
        >
          <a-select
            v-decorator="[
              'cancelFlag',
              {
                rules: [{ required: false, message: 'Please select cancelled' }]
              }
            ]"
          >
            <a-select-option value="0">Completed</a-select-option>
            <a-select-option value="1">Cancelled</a-select-option>
      </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import TourRecordApi from '@/api/api-cdb-customer-tourrecord'
import CustomerApi from '@/api/api-cdb-customer'

export default {
  name: 'CdbCustomerTourRecordList',
  components: {
    STable
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      // 加载中
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      currentTourRecordIndex: null,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { customerId: this.customerId, cancelFlag: '', tourCode: '', bookId: ''},
      // Status 状态
      statusList:[],
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: 'Tour Code',
          dataIndex: 'tourCode',
          scopedSlots: { customRender: 'tourCode' }
        },
        {
          title: 'Booking No.',
          dataIndex: 'bookId',
          scopedSlots: { customRender: 'bookId' }
        },
        {
          title: 'Status',
          dataIndex: 'cancelFlag',
          customRender: (value) => (value === '0') ? 'Completed' : 'Cancelled'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return TourRecordApi.query(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      // 总数统计
      totalData: { totalCancelled: 0, totalCompleted: 0 }
    }
  },
  mounted () {
    this.loadInitData()
    console.log('process.env.VUE_APP_OBS_PUBLIC_URL',process.env.VUE_APP_OBS_PUBLIC_URL)
  },
  methods: {
    async loadInitData () {
      if (this.customerId) {
        const res = await TourRecordApi.queryTotalByCustomerId(this.customerId)
        this.totalData = res.data
      }
    },
    showTourRecordsModal () {
      this.currentTourRecordIndex = true
      this.$nextTick(() => {
        this.editForm.setFieldsValue({ 'tourCode': null, 'bookId': null, 'cancelFlag': '0' })
      })
    },
    getOBSCodeUrl (bookId) {
      const env = process.env.NODE_ENV
      if (env === 'production' || env === 'test') {
        return process.env.VUE_APP_OBS_PUBLIC_URL + '/obs_queryBooking.do?bkrId=' + bookId
      } else {
        // 开发环境
        return `https://nike.supernettours.com/obs_queryBooking.do?bkrId=${ bookId }`
      }
    },
    // 处理编辑框关闭
    handleModalCancel () {
      this.currentTourRecordIndex = null
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'customerTourRecordId': recode.id }
      const customerId = this.customerId
      const that = this
      CustomerApi.deleteCustomerTourRecord(customerId, params).then(async res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Delete successfully !')
          if (this.customerId) {
            const res = await TourRecordApi.queryTotalByCustomerId(this.customerId)
            this.totalData = res.data
          }
          this.notifyTourInfoChange()
          that.$refs.table.refresh(false)
        }
      })
    },
    handleOk () {
    },
    handleModalConfirm () {
      this.saving = true
      const that = this
      const editForm = this.editForm
      const customerId = this.customerId
      editForm.validateFields((err) => {
        if (err) {
          this.saving = false
          return
        }
        var formData = editForm.getFieldsValue()
        CustomerApi.addCustomerTourRecord(customerId, formData).then(async res => {
          if (!that.mixinProcessHasBizErrorNotification(res)) {
            that.mixinProcessSuccessNotification('Add successfully !')
            if (this.customerId) {
              const res = await TourRecordApi.queryTotalByCustomerId(this.customerId)
              this.totalData = res.data
            }
            this.notifyTourInfoChange()
            that.$refs.table.refresh(true)
            that.handleModalCancel()
            this.saving = false
          }
          // 使用..then必须加上.catch保障代码执行顺序
        }).catch (e => {
          console.log('Tour record save error:', e)
          this.saving = false
        })
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    async handleQueryChange () {
      if (this.customerId) {
        const res = await TourRecordApi.queryTotalByCustomerId(this.customerId)
        this.totalData = res.data
      }
      this.$refs.table.refresh(true)
    },
    // 通知父组件更新
    notifyTourInfoChange () {
      this.$emit('change')
    },
    // 查询
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    // 重置查询条件
    reset () {
      this.queryParam = { tourCode: '', bookId: ''}
      this.refreshCurrentPage()
    },

  }
}
</script>

<style lang="less" scoped>
.plate-title {
   font-weight: 600;
   font-size: 1rem;
   // padding: 20px 0 8px 0;
   line-height: 32px;
 }
.plate-title:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 6px;
  background: #1890ff;
  position: relative;
  top: 3px;
}
// ::v-deep  .ant-select-selection {
//   width: 120px;
// }
::v-deep .ant-form-inline  {
  margin-bottom: 10px;
}
</style>